import type {
  PageSettingsSchema,
  SettingResponse,
  SettingsRequest,
} from '../model/types';
import type { AxiosRequestConfig } from 'axios';
import { monitoringInstance } from '@/shared/api/api-instances/monitoring/api-instance';

export class MonitoringSettingsApi {
  static getAllSettings(params = {}, options: AxiosRequestConfig = {}) {
    return monitoringInstance.get<PageSettingsSchema>(`/settings`, {
      ...options,
      params,
    });
  }

  static getSettingById(setting_id: string, options: AxiosRequestConfig = {}) {
    return monitoringInstance.get<SettingResponse>(
      `/settings/${setting_id}`,
      options,
    );
  }

  static editSetting(
    setting_id: string,
    payload: SettingsRequest,
    options: AxiosRequestConfig = {},
  ) {
    return monitoringInstance.put<SettingResponse>(
      `/settings/${setting_id}`,
      payload,
      options,
    );
  }
}